import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'messages'];

  connect() {
    console.log('Stimulus!');
  }

  append(event) {
    const [data, status, xhr] = event.detail;
    console.log(xhr.response);
    this.messagesTarget.innerHTML += xhr.response;

    this.inputTarget.value = '';
  }

  change() {
    console.log('change');
  }
}
